<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>
		<v-text-field
			browser-autocomplete="off"
			label="label pola"
			aria-label="label"
			for="date-field-props-label"
			id="date-field-props-label"
			v-model="fieldProps.label"
			class="text-xs-center"
			outline>
		</v-text-field>
		<v-text-field
			browser-autocomplete="off"
			label="hint"
			aria-label="hint"
			for="date-field-props-hint"
			id="date-field-props-hint"
			v-model="fieldProps.hint"
			class="text-xs-center"
			outline>
		</v-text-field>
		<v-checkbox v-model="minimum" :label="`Dolne ograniczenie daty`" aria-label="minimum date"></v-checkbox>
		<v-container grid-list-md v-if="minimum">
			<v-layout row wrap>
				<v-flex xs12 lg6>
					<v-menu
						ref="menu1"
						v-model="menu1"
						:close-on-content-click="false"
						:nudge-right="40"
						lazy
						transition="scale-transition"
						offset-y
						full-width
						max-width="290px"
						min-width="290px">
						<template v-slot:activator="{ on }">
							<v-text-field
								browser-autocomplete="off"
								v-model="fieldProps.min"
								for="date-field-props-date"
								id="date-field-props-date"
								aria-label="date menu item"
								prepend-icon="event"
								v-on="on"
								readonly
							></v-text-field>
						</template>
						<v-date-picker
							v-model="fieldProps.min"
							:first-day-of-week="1"
							no-title scrollable @input="menu1 = false"
							locale="pl-PL"
						></v-date-picker>
					</v-menu>
				</v-flex>
			</v-layout>
		</v-container>
		<v-checkbox v-model="maximum" :label="`Górne ograniczenie daty`" aria-label="maximum date"></v-checkbox>
		<v-container grid-list-md v-if="maximum">
			<v-layout row wrap>
				<v-flex xs12 lg6>
					<v-menu
						ref="menu2"
						v-model="menu2"
						:close-on-content-click="false"
						:nudge-right="40"
						lazy
						transition="scale-transition"
						offset-y
						full-width
						max-width="290px"
						min-width="290px"
					>
						<template v-slot:activator="{ on }">
							<v-text-field
								browser-autocomplete="off"
								v-model="fieldProps.max"
								:label="`Górne ograniczenie daty`"
								prepend-icon="event"
								aria-label="max date"
								v-on="on"
								readonly
							></v-text-field>
						</template>
						<v-date-picker
							v-model="fieldProps.max"
							:first-day-of-week="1"
							no-title scrollable
							@input="menu2 = false"
							locale="pl-PL"
						></v-date-picker>
					</v-menu>
				</v-flex>
			</v-layout>
		</v-container>
		<v-checkbox v-model="fieldProps.required" :label="`Wymagane`" aria-label="mandatory"></v-checkbox>
		<v-checkbox v-model="fieldProps.view" :label="`Wyświetlanie na podglądzie`"
			aria-label="show on print view"></v-checkbox>
	</div>
</template>

<script>
	export default {
		name: "dateFieldProps",

		props: {
			value: Object,
		},

		data() {
			return {
				fieldProps: this.value,
				minimum: false,
				maximum: false,
				menu1: false,
				menu2: false,
			};
		},

		watch: {
			fieldProps: {
				handler() {
					this.$emit("input", this.fieldProps);
				},
				deep: true,
			},
			value: {
				handler (val) {
					this.minimum = val.min;
					this.maximum = val.max;
				},
				deep: true,
				immediate: true
			}
		},
	};
</script>

<style scoped>

</style>
